const action = 'TravelAlone';

const attempt = () => {
  const result = {
    success: true
  };

  return result;
};

const executeSideEffects = (context, result) => {
  const { party } = context;
  const { history } = party;

  // Track action
  history.add({ action, result }, context);

  return {};
};

const travelAlone = onDone => ({
  title: '"I trust no one"',
  action,
  enabled: () => true,
  execute: context => {
    const result = attempt(context);
    executeSideEffects(context, result);

    onDone();

    return {};
  },
  tooltips: [['Alone']]
});

export default travelAlone;
